<div class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1 class="m-0 text-dark">Users</h1>
            </div>
            <!-- /.col -->
            <!-- <div class="col-sm-6 text-right">
                <p-button type="button" class="mr-2" (click)="onEdit(0)">Add Email Setting</p-button>
                
            </div> -->
            <!-- /.col -->
        </div>
        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
</div>
<!-- /.content-header -->
<section class="content">
    <div class="container-fluid">
        <p-table [value]="emailSettings" [tableStyle]="{ 'min-width': '50rem' }">
            <ng-template pTemplate="header">
                <tr>
                    <th>Email</th>
                    <th>Host</th>
                    <th>User Name</th>
                    <th>Password</th>
                    <th>Port</th>
                    <th>EnableSSl</th>
                    <th>DefaultEmail</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-emailSetting>
                <tr>

                    <td>{{ emailSetting.email }}</td>
                    <td>{{ emailSetting.host }}</td>
                    <td>{{ emailSetting.userName }}</td>
                    <td>{{ emailSetting.password }}</td>
                    <td>{{ emailSetting.port }}</td>
                    <td>{{ emailSetting.enableSSl }}</td>
                    <td>{{ emailSetting.defaultEmail }}</td>
                 
                    <td style="max-width: 200px">
                        <button                  
                        class="btn btn-light mr-2"
                        ngbTooltip="Edit Contact"
                        (click)="onEdit(emailSetting['id'])"
                      >
                        Edit
                      </button>

                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</section>
<p-sidebar [(visible)]="sidebarVisible4" position="right">
    <app-add-update-email-setting [emailSettingId]="emailSettingId"></app-add-update-email-setting>
    
</p-sidebar>
